<style scoped lang="less">
  .timetable-cell {
    position: relative;
    height: 100%;
    /*买断*/
    .opended {
      background: #00DEFF;
      z-index: 10;
      height: 38px;
    }
    /*短期固定*/
    .short-term {
      background: #1B5E20;
      z-index: 5;
      height: 38px;
    }
    /*绑定*/
    .book-work {
      background: #FFCCFF;
      z-index: 30;
      height: 38px;
    }
    /*常规*/
    .schedule {
      background: #FF9900;
      z-index: 40;
      height: 39px;
    }
    .student-leave {
      background: #DA70D6;
    }
    /*试听*/
    .test {
      background: #ffff00;
      z-index: 50;
      height: 39px;
    }
    /*空课*/
    .free {
      background: #66CC33;
      z-index: 20;
      height: 36px;
    }
    /*陪练*/
    .partner {
      background: #FF6B6B;
      z-index: 40;
      height: 39px;
    }

    /*请假*/
    .leave {
      z-index: 60;
      height: 40px;
      i {
        background: #AEAEAE;
        opacity: 0.6;
      }
    }

    .text {
      z-index: 20;
    }
    .active {
      z-index: 100;
      box-shadow: 4px 4px 8px 0 rgba(0, 0, 0, .6);
      border-bottom: 1px solid #505050;
    }

    i {
      position: relative;
      display: block;
      height: 40px;
      font-size: 12px;
      font-weight: 400;
      font-style: normal;
    }
  }
</style>
<style lang="less">
  .poptip {
    position: absolute;
    top: 0;
    height: 40px;

    i {
      width: 100%;
      height: 100%;
    }

    .ivu-poptip {
      width: 100%;
      height: 100%;

      .ivu-poptip-rel {
        width: 100%;
        height: 100%;
      }
    }

  }
</style>
<template>
  <div v-if="column.hour" class="timetable-cell">
    <!--买断时间-->
    <template v-for="item in bookTchOpenedTimeList">
      <div class="poptip" @mouseover="onMouseOver(item)" @mouseout="onMouseOut"
           :class="{opended: true, active: item.id === activeId}"
           :style="{left: item.startIndex / 12 * 100 + '%', width: item.colspan / 12 * 100 + '%' }">
        <Poptip title="买断时间" placement="top" trigger="hover"  :delay="delay" transfer append-to-body>
          <div slot="content">
            <ul>
              <li>类型: 买断时间</li>
              <li>开始时间: {{item.startTimeStr}}</li>
              <li>结束时间: {{item.endTimeStr}}</li>
              <li>课时: {{item.duration}}</li>
              <li v-if="item.studyAdviserNickName">学习顾问: {{item.studyAdviserNickName}}</li>
              <li v-if="item.adviserNickName">课程顾问: {{item.adviserNickName}}</li>
              <li v-if="item.tchStudyAdviserName">外管: {{item.tchStudyAdviserName}}</li>
              <li>状态: {{item.statusText}}</li>
              <li v-if="item.remark">备注: {{item.remark}}</li>
            </ul>
          </div>
          <i></i>
        </Poptip>
      </div>
    </template>
    <!--买断时间-->

    <!--短期固定时间-->
    <template v-for="item in bookTchShortTermOpenedTimeList">
      <div class="poptip" @mouseover="onMouseOver(item)" @mouseout="onMouseOut"
           :class="{'short-term': true, active: item.id === activeId}"
           :style="{left: item.startIndex / 12 * 100 + '%', width: item.colspan / 12 * 100 + '%' }">
        <Poptip title="短期固定时间" placement="top" trigger="hover"  :delay="delay" transfer append-to-body>
          <div slot="content">
            <ul>
              <li>类型: 短期固定时间</li>
              <li>开始时间: {{item.startTimeStr}}</li>
              <li>结束时间: {{item.endTimeStr}}</li>
              <li>课时: {{item.duration}}</li>
              <li v-if="item.studyAdviserNickName">学习顾问: {{item.studyAdviserNickName}}</li>
              <li v-if="item.adviserNickName">课程顾问: {{item.adviserNickName}}</li>
              <li v-if="item.tchStudyAdviserName">外管: {{item.tchStudyAdviserName}}</li>
              <li>状态: {{item.statusText}}</li>
              <li v-if="item.remark">备注: {{item.remark}}</li>
            </ul>
          </div>
          <i></i>
        </Poptip>
      </div>
    </template>
    <!--短期固定时间-->

    <!--常规课-->
    <template v-for="item in tchScheduleBookLessonOpenedDtoList">
      <div class="poptip" @mouseover="onMouseOver(item)" @mouseout="onMouseOut"
           :class="{schedule: true, 'student-leave': item.lsnSelStatus === 4 , active: item.id === activeId}"
           :style="{left: item.startIndex / 12 * 100 + '%', width: item.colspan / 12 * 100 + '%' }">
        <Poptip title="常规课" placement="top" trigger="hover"  :delay="delay" transfer append-to-body>
          <div slot="content">
            <ul>
              <li>类型: 常规课</li>
              <li>开始时间: {{item.lsnBeginTimeStr}}</li>
              <li>结束时间: {{item.lsnEndTimeStr}}</li>
              <li>学生: {{item.userNickname}} - {{item.uId}}</li>
              <li>状态: {{item.lsnSelStatusText}}</li>
              <li v-if="item.studyAdviserNickName">学习顾问: {{item.studyAdviserNickName}}</li>
              <li v-if="item.adviserNickName">课程顾问: {{item.adviserNickName}}</li>
              <li v-if="item.tchStudyAdviserName">外管: {{item.tchStudyAdviserName}}</li>
              <li v-if="item.uid">学员id: {{item.uid}}</li>
              <li v-if="item.remark">备注: {{item.remark}}</li>
            </ul>
          </div>
          <i v-if="item.lsnSelStatus === 4">(假){{item.userNickname}}</i>
          <i v-if="item.isChange === 1">(替){{item.userNickname}}</i>
          <i v-else>{{item.userNickname}}</i>
        </Poptip>
      </div>
    </template>
    <!--常规课-->

    <!--陪练课-->
    <template v-for="item in bookTchRandomPartnerTimeDtoList">
      <div class="poptip" @mouseover="onMouseOver(item)" @mouseout="onMouseOut"
           :class="{partner: true, active: item.id === activeId}"
           :style="{left: item.startIndex / 12 * 100 + '%', width: item.colspan / 12 * 100 + '%' }">
        <Poptip title="陪练课" placement="top" trigger="hover"  :delay="delay" transfer append-to-body>
          <div slot="content">
            <ul>
              <li>类型: 陪练课</li>
              <li>开始时间: {{item.lsnBeginTimeStr}}</li>
              <li>结束时间: {{item.lsnEndTimeStr}}</li>
              <li>学生: {{item.userNickname}} - {{item.uId}}</li>
              <li>状态: {{item.lsnSelStatusText}}</li>
              <li v-if="item.studyAdviserNickName">学习顾问: {{item.studyAdviserNickName}}</li>
              <li v-if="item.adviserNickName">课程顾问: {{item.adviserNickName}}</li>
              <li v-if="item.tchStudyAdviserName">外管: {{item.tchStudyAdviserName}}</li>
              <li v-if="item.uid">学员id: {{item.uid}}</li>
              <li v-if="item.remark">备注: {{item.remark}}</li>
            </ul>
          </div>
          <i v-if="item.lsnSelStatus === 4">(假){{item.userNickname}}</i>
          <i v-if="item.isChange === 1">(替){{item.userNickname}}</i>
          <i v-else>{{item.userNickname}}</i>
        </Poptip>
      </div>
    </template>
    <!--陪练课-->

    <!--试听课-->
    <template v-for="item in tchScheduleBookLessonTestOpenedDtoList">
      <div class="poptip" @mouseover="onMouseOver(item)" @mouseout="onMouseOut"
           :class="{test: true, active: item.id === activeId}"
           :style="{left: item.startIndex / 12 * 100 + '%', width: item.colspan / 12 * 100 + '%' }">
        <Poptip title="试听课" placement="top" trigger="hover"  :delay="delay" transfer append-to-body>
          <div slot="content">
            <ul>
              <li>类型: 试听课</li>
              <li>开始时间: {{item.lsnBeginTimeStr}}</li>
              <li>结束时间: {{item.lsnEndTimeStr}}</li>
              <li>学生: {{item.userNickname}} - {{item.uId}}</li>
              <li>状态: {{item.statusText}}</li>
              <li v-if="item.studyAdviserNickName">学习顾问: {{item.studyAdviserNickName}}</li>
              <li v-if="item.adviserNickName">课程顾问: {{item.adviserNickName}}</li>
              <li v-if="item.tchStudyAdviserName">外管: {{item.tchStudyAdviserName}}</li>
              <li v-if="item.remark">备注: {{item.remark}}</li>
            </ul>
          </div>
          <i>{{item.userNickname}}</i>
        </Poptip>
      </div>
    </template>
    <!--试听课-->

    <!--绑定课-->
    <template v-for="item in bookWorkLessonOpenedTimeDtoList">
      <div class="poptip" @mouseover="onMouseOver(item)" @mouseout="onMouseOut"
           :class="{'book-work': true, active: item.id === activeId}"
           :style="{left: item.startIndex / 12 * 100 + '%', width: item.colspan / 12 * 100 + '%' }">
        <Poptip title="绑定课" placement="top" trigger="hover"  :delay="delay" transfer append-to-body>
          <div slot="content">
            <ul>
              <li>类型: 绑定课</li>
              <li>开始时间: {{item.startTimeStr}}</li>
              <li>结束时间: {{item.endTimeStr}}</li>
              <li>学生: {{item.nickname}} - {{item.uid}}</li>
              <li v-if="item.studyAdviserNickName">学习顾问: {{item.studyAdviserNickName}}</li>
              <li v-if="item.adviserNickName">课程顾问: {{item.adviserNickName}}</li>
              <li v-if="item.tchStudyAdviserName">外管: {{item.tchStudyAdviserName}}</li>
              <li v-if="item.remark">备注: {{item.remark}}</li>
            </ul>
          </div>
          <i v-if="item.isLeave === 'y'">(假){{item.nickname}}</i>
          <i v-else>{{item.nickname}}</i>
        </Poptip>
      </div>
    </template>
    <!--绑定课-->

    <!--空课-->
    <template v-for="item in bookTchRandomOpenedTimeDtoList">
      <div class="poptip" @mouseover="onMouseOver(item)" @mouseout="onMouseOut"
           :class="{'free': true, active: item.id === activeId}"
           :style="{left: item.startIndex / 12 * 100 + '%', width: item.colspan / 12 * 100 + '%' }">
        <Poptip title="空课" placement="top" trigger="hover"  :delay="delay" transfer append-to-body>
          <div slot="content">
            <ul>
              <li>类型: 空课</li>
              <li>开始时间: {{item.startTimeStr}}</li>
              <li>结束时间: {{item.endTimeStr}}</li>
              <li>状态: {{item.statusText}}</li>
              <li v-if="item.remark">备注: {{item.remark}}</li>
            </ul>
          </div>
          <i></i>
        </Poptip>
      </div>
    </template>
    <!--空课-->

    <!--老师请假-->
    <template v-for="item in bookTchLeaveTimeDtoList">
      <div class="poptip" @mouseover="onMouseOver(item)" @mouseout="onMouseOut"
           :class="{'leave': true, active: item.id === activeId}"
           :style="{left: item.startIndex / 12 * 100 + '%', width: item.colspan / 12 * 100 + '%' }">
        <Poptip title="老师请假" placement="top" trigger="hover"  :delay="delay" transfer append-to-body>
          <div slot="content">
            <ul>
              <li>类型: 老师请假</li>
              <li>老师: {{item.tchFirstName}} {{item.tchLastName}}</li>
              <li>开始时间: {{item.startTimeStr}}</li>
              <li>结束时间: {{item.endTimeStr}}</li>
              <li>时长: {{item.duration}} 分钟</li>
              <li>状态: {{item.statusText}}</li>
              <li v-if="item.remark">备注: {{item.remark}}</li>
            </ul>
          </div>
          <i></i>
        </Poptip>
      </div>
    </template>
    <!--老师请假-->

  </div>
  <div v-else-if="column.render" style="text-align: center">
    <render-cell :params="row" :render="column.render"></render-cell>
  </div>
  <div v-else style="text-align: center">
    {{row[column.key]}}
  </div>
</template>
<script>
  import renderCell from './renderCell'

  export default {
    components: {renderCell},
    name: 'TimetableCell',
    props: {
      row: {
        type: Object,
      },
      column: {
        type: Object,
      },
      activeId: {
        type: Number,
      },
      types: {
        type: Array,
      },
    },
    data () {
      return {
        delay: 500
      }
    },
    computed: {
      // 买断时间
      bookTchOpenedTimeList: function () {
        if (!this.row || !this.row.bookTchOpenedTimeDtoList) {
          return []
        }

        if (this.types.indexOf('opened') === -1) {
          return []
        }

        // 买断时间（排除短期固定时间）
        let bookTchOpenedTimeList = this.row.bookTchOpenedTimeDtoList.filter(
          item => (!item.endDate || item.endDate === 0) && item.startTime / 60 / 60 < (this.column.hour + 1) && item.endTime / 60 / 60 >
            this.column.hour).map(item => Object.assign({}, item))

        bookTchOpenedTimeList.forEach(item => {
          let startHour = Math.floor(item.startTime / 60 / 60)
          let startMinute = item.startTime / 60 % 60

          if (startHour < this.column.hour) {
            item.startIndex = 0
          } else {
            item.startIndex = Math.floor(startMinute / 5)
          }

          let duration = item.endTime - this.column.hour * 60 * 60
          if (duration >= 3600) {
            item.colspan = 12 - item.startIndex
          } else {
            item.colspan = Math.ceil(duration / 60 / 5 - item.startIndex)
          }
        })

        return bookTchOpenedTimeList
      },
      // 短期固定时间
      bookTchShortTermOpenedTimeList: function () {
        if (!this.row || !this.row.bookTchOpenedTimeDtoList) {
          return []
        }

        if (this.types.indexOf('shortTerm') === -1) {
          return []
        }

        let list = this.row.bookTchOpenedTimeDtoList.filter(
          item => {
            if (!item.endDate || item.endDate <= 0) return false

            // 过了有效期则不渲染
            const endDateMoment = this.$moment.unix(item.endDate)
            const rowDateMoment = this.$moment(this.row.dateStr, 'YYYY-MM-DD')
            if (rowDateMoment.isAfter(endDateMoment, 'day')) return false

            return item.startTime / 60 / 60 < (this.column.hour + 1) && item.endTime / 60 / 60 > this.column.hour
          }).map(item => Object.assign({}, item))

        list.forEach(item => {
          let startHour = Math.floor(item.startTime / 60 / 60)
          let startMinute = item.startTime / 60 % 60

          if (startHour < this.column.hour) {
            item.startIndex = 0
          } else {
            item.startIndex = Math.floor(startMinute / 5)
          }

          let duration = item.endTime - this.column.hour * 60 * 60
          if (duration >= 3600) {
            item.colspan = 12 - item.startIndex
          } else {
            item.colspan = Math.ceil(duration / 60 / 5 - item.startIndex)
          }
        })

        return list
      },
      // 常规课
      tchScheduleBookLessonOpenedDtoList: function () {
        if (!this.row || !this.row.tchScheduleBookLessonOpenedDtoList) {
          return []
        }

        if (this.types.indexOf('schedule') === -1) {
          return []
        }

        let tchScheduleBookLessonOpenedDtoList = this.row.tchScheduleBookLessonOpenedDtoList.filter(
          item => {
            let startHour = new Date(item.lsnBeginTime * 1000).getHours()
            let endHour = new Date(item.lsnEndTime * 1000).getHours()
            return startHour < (this.column.hour + 1) && endHour >= this.column.hour
          }).map(item => Object.assign({}, item))

        tchScheduleBookLessonOpenedDtoList.forEach(item => {
          let startDate = new Date(item.lsnBeginTime * 1000)
          let startHour = startDate.getHours()
          if (startHour < this.column.hour) {
            item.startIndex = 0
          } else {
            item.startIndex = Math.floor(startDate.getMinutes() / 5)
          }

          let endDate = new Date(item.lsnEndTime * 1000)
          if (endDate.getHours() >= this.column.hour + 1) {
            item.colspan = 12 - item.startIndex
          } else {
            item.colspan = Math.ceil(endDate.getMinutes() / 5 - item.startIndex)
          }
        })

        return tchScheduleBookLessonOpenedDtoList
      },
      //陪练课
      bookTchRandomPartnerTimeDtoList: function () {
        if (!this.row || !this.row.bookTchRandomPartnerTimeDtoList) {
          return []
        }

        if (this.types.indexOf('partner') === -1) {
          return []
        }

        let bookTchRandomPartnerTimeDtoList = this.row.bookTchRandomPartnerTimeDtoList.filter(
          item => {
            let startHour = new Date(item.lsnBeginTime * 1000).getHours()
            let endHour = new Date(item.lsnEndTime * 1000).getHours()
            return startHour < (this.column.hour + 1) && endHour >= this.column.hour
          }).map(item => Object.assign({}, item))

        bookTchRandomPartnerTimeDtoList.forEach(item => {
          let startDate = new Date(item.lsnBeginTime * 1000)
          let startHour = startDate.getHours()
          if (startHour < this.column.hour) {
            item.startIndex = 0
          } else {
            item.startIndex = Math.floor(startDate.getMinutes() / 5)
          }

          let endDate = new Date(item.lsnEndTime * 1000)
          if (endDate.getHours() >= this.column.hour + 1) {
            item.colspan = 12 - item.startIndex
          } else {
            item.colspan = Math.ceil(endDate.getMinutes() / 5 - item.startIndex)
          }
        })

        return bookTchRandomPartnerTimeDtoList
      },
      // 绑定课
      bookWorkLessonOpenedTimeDtoList: function () {
        if (!this.row || !this.row.bookWorkLessonOpenedTimeDtoList) {
          return []
        }

        if (this.types.indexOf('book') === -1) {
          return []
        }

        let bookWorkLessonOpenedTimeDtoList = this.row.bookWorkLessonOpenedTimeDtoList.filter(
          item => {
            let startHour = Math.floor(item.startTime / 60 / 60)
            let endHour = Math.floor(item.endTime / 60 / 60)
            return startHour < (this.column.hour + 1) && endHour >= this.column.hour
          }).map(item => Object.assign({}, item))

        bookWorkLessonOpenedTimeDtoList.forEach(item => {
          let startHour = Math.floor(item.startTime / 60 / 60)
          let startMinute = Math.floor(item.startTime / 60 % 60)
          if (startHour < this.column.hour) {
            item.startIndex = 0
          } else {
            item.startIndex = Math.floor(startMinute / 5)
          }

          let endHour = Math.floor(item.endTime / 60 / 60)
          let endMinute = Math.floor(item.endTime / 60 % 60)
          if (endHour >= this.column.hour + 1) {
            item.colspan = 12 - item.startIndex
          } else {
            item.colspan = Math.ceil(endMinute / 5 - item.startIndex)
          }
        })

        return bookWorkLessonOpenedTimeDtoList
      },
      // 试听课
      tchScheduleBookLessonTestOpenedDtoList: function () {
        if (!this.row || !this.row.tchScheduleBookLessonTestOpenedDtoList) {
          return []
        }

        if (this.types.indexOf('test') === -1) {
          return []
        }

        let tchScheduleBookLessonTestOpenedDtoList = this.row.tchScheduleBookLessonTestOpenedDtoList.filter(
          item => {
            let startHour = new Date(item.lsnBeginTime * 1000).getHours()
            let endHour = new Date(item.lsnEndTime * 1000).getHours()
            return startHour < (this.column.hour + 1) && endHour >= this.column.hour
          }).map(item => Object.assign({}, item))

        tchScheduleBookLessonTestOpenedDtoList.forEach(item => {
          let startDate = new Date(item.lsnBeginTime * 1000)
          let startHour = startDate.getHours()
          if (startHour < this.column.hour) {
            item.startIndex = 0
          } else {
            item.startIndex = Math.floor(startDate.getMinutes() / 5)
          }

          let endDate = new Date(item.lsnEndTime * 1000)
          if (endDate.getHours() >= this.column.hour + 1) {
            item.colspan = 12 - item.startIndex
          } else {
            item.colspan = Math.ceil(endDate.getMinutes() / 5 - item.startIndex)
          }
        })

        return tchScheduleBookLessonTestOpenedDtoList
      },
      // 空课
      bookTchRandomOpenedTimeDtoList: function () {
        if (!this.row || !this.row.bookTchRandomOpenedTimeDtoList) {
          return []
        }

        if (this.types.indexOf('free') === -1) {
          return []
        }

        let bookTchRandomOpenedTimeDtoList = this.row.bookTchRandomOpenedTimeDtoList.filter(
          item => {
            let startHour = new Date(item.startTime * 1000).getHours()
            let endHour = new Date(item.endTime * 1000).getHours()
            return startHour < (this.column.hour + 1) && endHour >= this.column.hour
          }).map(item => Object.assign({}, item))

        bookTchRandomOpenedTimeDtoList.forEach(item => {
          let startDate = new Date(item.startTime * 1000)
          let startHour = startDate.getHours()
          if (startHour < this.column.hour) {
            item.startIndex = 0
          } else {
            item.startIndex = Math.floor(startDate.getMinutes() / 5)
          }

          let endDate = new Date(item.endTime * 1000)
          if (endDate.getHours() >= this.column.hour + 1) {
            item.colspan = 12 - item.startIndex
          } else {
            item.colspan = Math.ceil(endDate.getMinutes() / 5 - item.startIndex)
          }
        })

        return bookTchRandomOpenedTimeDtoList
      },
      // 老师请假
      bookTchLeaveTimeDtoList: function () {
        if (!this.row || !this.row.bookTchLeaveTimeDtoList) {
          return []
        }

        if (this.types.indexOf('leave') === -1) {
          return []
        }

        let bookTchLeaveTimeDtoList = this.row.bookTchLeaveTimeDtoList.filter(
          item => {
            // 结束时间为空或开始结束相同的空段，直接丢弃，避免被当成整天请假
            if (!item.endTime || item.endTime <= item.startTime) {
              return false
            }

            let startHour = 23
            let endHour = 0
            if (new Date(this.row.dateStr).getDate() === new Date(item.startTime * 1000).getDate() &&
              new Date(this.row.dateStr).getDate() === new Date(item.endTime * 1000 - 1).getDate()) {
              startHour = Math.min(Math.floor(new Date(item.startTime * 1000).getHours()), startHour)
              endHour = Math.max(Math.floor(new Date(item.endTime * 1000 - 1).getHours()), endHour)
            } else if (new Date(this.row.dateStr).getDate() === new Date(item.startTime * 1000).getDate() &&
              new Date(this.row.dateStr).getDate() !== new Date(item.endTime * 1000 - 1).getDate()) {
              startHour = Math.min(Math.floor(new Date(item.startTime * 1000).getHours()), startHour)
              endHour = Math.max(23, endHour)
            } else if (new Date(this.row.dateStr).getDate() !== new Date(item.startTime * 1000).getDate() &&
              new Date(this.row.dateStr).getDate() === new Date(item.endTime * 1000 - 1).getDate()) {
              startHour = Math.min(9, startHour)
              endHour = Math.max(Math.floor(new Date(item.endTime * 1000 - 1).getHours()), endHour)
            } else if (new Date(this.row.dateStr).getDate() !== new Date(item.startTime * 1000).getDate() &&
              new Date(this.row.dateStr).getDate() !== new Date(item.endTime * 1000 - 1).getDate()) {
              startHour = Math.min(9, startHour)
              endHour = Math.max(23, endHour)
            }
            return startHour < (this.column.hour + 1) && endHour >= this.column.hour
          }).map(item => Object.assign({}, item))

        bookTchLeaveTimeDtoList.forEach(item => {
          let startDate = new Date(item.startTime * 1000).getDate() !== new Date(this.row.dateStr).getDate() ? new Date(this.row.dateStr) : new Date(item.startTime * 1000)
          let startHour = startDate.getHours()
          if (startHour < this.column.hour) {
            item.startIndex = 0
          } else {
            item.startIndex = Math.floor(startDate.getMinutes() / 5)
          }

          let endDate = new Date(item.endTime * 1000 - 1).getDate() !== new Date(this.row.dateStr).getDate() ? new Date(this.row.dateStr + ' 23:00:00') : new Date(item.endTime * 1000 - 1)
          if (endDate.getHours() >= this.column.hour + 1) {
            item.colspan = 12 - item.startIndex
          } else {
            item.colspan = Math.ceil(endDate.getMinutes() / 5 - item.startIndex)
          }
        })

        return bookTchLeaveTimeDtoList
      },
    },
    methods: {
      onMouseOver (row) {
        console.log(row.id)
        this.$emit('hover-active', row.id)
      },
      onMouseOut () {
        this.$emit('hover-active', -1)
      },
    },
    mounted () {
    },
    watch: {},
  }
</script>





// WEBPACK FOOTER //
// TimetableCell.vue?57a4fc4e